export default __webpack_public_path__ + "static/media/user1.0c4332f5.png";